import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, Span, ProgressBox, ProgressStat } from '../styles';
import { greenScaleColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return greenScaleColors[4];
  }
  if (value < 50) {
    return greenScaleColors[3];
  }
  if (value < 75) {
    return greenScaleColors[1];
  }
  return greenScaleColors[0];
};

const RecursosTransicion = ({ user, background, number }) => {
  const recursos = (parseFloat(user['RECTR']) / 5) * 100;
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h1>5. Recursos para la Transición Escolar</h1>
          <p className='justified'>
            La escala de Recursos para la Transición Escolar se enfoca en
            identificar los recursos personales que consideras que tienes para
            afrontar de manera efectiva los cambios y desafíos asociados al paso
            a la enseñanza media.{' '}
            <strong>
              Reconocer nuestras emociones positivas puede fortalecer la
              confianza en nuestras habilidades y lo que podemos lograr, lo que
              a su vez nos permite mantener una actitud optimista
            </strong>{' '}
            y ser perseverantes ante las nuevas situaciones y posibles
            obstáculos que podamos enfrentar en esta nueva etapa escolar.
          </p>
          <p className='justified'>
            El siguiente gráfico representa tu puntaje global obtenido en esta
            escala. Resultados en
            <Span strong color={greenScaleColors[4]}>
              {' '}
              VERDE{' '}
            </Span>
            sugieren que tienes una alta confianza en tus recursos personales
            para enfrentar esta nueva etapa escolar. Resultados en{' '}
            <Span strong color={greenScaleColors[0]}>
              GRIS
            </Span>{' '}
            sugieren que es importante que puedas trabajar para aumentar la
            confianza en tus propias capacidades y tener una visión más
            optimista sobre los nuevos desafíos,{' '}
            <strong>
              lo que te permitirá lograr de mejor forma las metas que te
              propongas
            </strong>
            .
          </p>
          <div
            className='progress-info-group'
            style={{ marginTop: 56, marginBottom: 36 }}
          >
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={recursos}
                  backColor={() => getColor(100 - recursos)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{recursos.toFixed(0)}</ProgressStat>
              </div>
            </div>
          </div>
          <p className='justified'>
            A continuación te presentamos tus puntajes obtenidos en las
            distintas subescalas que componen este puntaje, para que
            identifiques tus principales fortalezas y aspectos que puedes
            mejorar.
          </p>
          <p className='justified'>
            Recuerda que siempre puedes buscar apoyo y orientación en tus
            docentes, padres u psicólogo/a del colegio.
          </p>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default RecursosTransicion;
